<template>
  <div class="container">
    <div class="login-bg">
      <div class="login-form">
        <div class="s-field" :class="{'is-focus':info.name}">
          <input type="text" v-model="info.name" class="s-input" >
          <label>手机号码</label>
        </div>
        <div class="s-field" :class="{'is-focus':info.password}">
          <input type="password" v-model="info.password" class="s-input" >
          <label>密码</label>
        </div>
        <button class="s-button s-button-primary  s-button-block" @click="login">登录</button>
        <div class="register-link">
          <router-link :to="{name:'infoAdd'}" class="register-link">注册</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/utils/config'
import auth from '@/utils/auth'
export default {
  name: 'login',
  data () {
    return {
      info: {

      }
    }
  },
  methods: {
    login () {
      this.$http.post(`${config.HOST}douyin/v1/user/login`, this.info).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            auth.setToken(data.data.token)
            this.$router.push({
              name: 'home'
            })
          } else {
            this.$toast.show(data.errorMessage || '登录失败')
          }
        },
        response => {
          // error callback
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../components/button/button.less";
  .login-bg{
    background: url(../../assets/images/login_bg.jpg) no-repeat;
    background-position: center;
    background-size: cover;
    position: fixed;
    width:100%;
    height:100%;
  }
  .login-form{
    width:300px;
    transform: translate(-50%,-50%);
    top:50%;
    left:50%;
    position: fixed;
    padding: 0 25px;
  }
  .s-field{
    position: relative;
    margin-bottom: 25px;
    label{
      position: absolute;
      font-size: 14px;
      bottom: 8px;
      color: #999;
      pointer-events: none;
      transition: all 0.2s;
    }
    input{
      background: transparent;
      border:0;
      font-size: 14px;
      border-bottom: 1px solid #D8D8D8;
      width: 100%;
      color:#fff;
      outline: none;
      padding: 8px 0;
      &:focus + label{
        font-size: 12px;
        color:#fff;
        bottom: 28px;
      }
    }
    &.is-focus{
      label{
        font-size: 12px;
        color:#fff;
        bottom: 28px;
      }
    }
  }
  .register-link{
    text-align: center;
    margin-top: 15px;
    a{
      color: #FE2B55;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/user/Login.vue